module.exports = __webpack_public_path__ + "static/img/img_check.d8879f4.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/regionTutorialIos/img_check.png
// module id = 1104
// module chunks = 1